import React from 'react';
import './stock-left.scss';
import Icon from '../../mweb/Icon/Icon';

const StockLeft = ({ message = 'Only few left' }) => {
  return (
    <div className="stock-left">
      <Icon class="icon-clock-red stock-left--icon" size={16} />
      <div className="stock-left--message">{message}</div>
    </div>
  );
};

export default StockLeft;
